import { Component } from '@angular/core';
import { LandingToolbarComponent } from '../landing-toolbar/landing-toolbar.component';
import { LandingFooterComponent } from '../landing-footer/landing-footer.component';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [
    LandingFooterComponent,
    LandingToolbarComponent
  ],
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss', '../../../app.component.scss']
})
export class PrivacyComponent {

  mail: string = 'pqrs@workbiservices.com';

}
